import type { ReactNode } from 'react';
import '../modal/ModalBase.css';
import ModalPortal from '../modal/ModalPortal';
import './RecordDetailsModal.css';

export type RecordDetailRow = {
  label: string;
  value: ReactNode;
};

export type RecordDetailAction = {
  label: string;
  onClick: () => void;
  danger?: boolean;
};

type Props = {
  title: string;
  summary?: ReactNode;
  rows: RecordDetailRow[];
  note?: string | null;
  noteLabel?: string;
  extra?: ReactNode;
  actions?: RecordDetailAction[];
  closeLabel?: string;
  onClose: () => void;
};

const RecordDetailsModal = ({
  title,
  summary,
  rows,
  note,
  noteLabel = 'Комментарий',
  extra,
  actions = [],
  closeLabel = 'Закрыть',
  onClose,
}: Props) => {
  return (
    <ModalPortal>
      <div className="modal-overlay" onClick={onClose}>
        <div
          className="modal record-details-modal"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="record-details-title"
        >
          <h3 id="record-details-title">{title}</h3>
          {summary ? (
            <div className="record-details-summary">{summary}</div>
          ) : null}
          <div className="modal-body record-details-body">
            {rows.map((row, index) => (
              <div key={`${row.label}-${index}`} className="record-details-row">
                <span>{row.label}</span>
                {typeof row.value === 'string' ||
                typeof row.value === 'number' ? (
                  <strong>{row.value}</strong>
                ) : (
                  <div className="record-details-value">{row.value}</div>
                )}
              </div>
            ))}
            {extra || null}
            {note !== undefined ? (
              <div className="record-details-note">
                <span>{noteLabel}</span>
                <p>{(note || '').trim() || '—'}</p>
              </div>
            ) : null}
          </div>
          {actions.length > 0 ? (
            <div className="record-details-actions">
              {actions.map((action) => (
                <button
                  key={action.label}
                  type="button"
                  className={
                    action.danger
                      ? 'btn-save record-details-danger'
                      : 'btn-save'
                  }
                  onClick={action.onClick}
                >
                  {action.label}
                </button>
              ))}
            </div>
          ) : null}
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              {closeLabel}
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default RecordDetailsModal;
